var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReturnShopPortalsInstructionsDocument.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-36853a82\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReturnShopPortalsInstructionsDocument.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/views/returnShopPortals/ReturnShopPortalsInstructionsDocument.vue
// module id = 912
// module chunks = 1